var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41669 10.0833C2.41669 7.39971 2.41669 6.05792 2.93895 5.03292C3.39834 4.13131 4.13137 3.39828 5.03298 2.93889C6.05798 2.41663 7.39977 2.41663 10.0834 2.41663H13.9167C16.6003 2.41663 17.9421 2.41663 18.9671 2.93889C19.8687 3.39828 20.6017 4.13131 21.0611 5.03292C21.5834 6.05792 21.5834 7.39971 21.5834 10.0833C21.5834 12.7669 21.5834 14.1087 21.0611 15.1337C20.6017 16.0353 19.8687 16.7683 18.9671 17.2277C17.9421 17.75 16.6003 17.75 13.9167 17.75H10.0834C7.39977 17.75 6.05798 17.75 5.03298 17.2277C4.13137 16.7683 3.39834 16.0353 2.93895 15.1337C2.41669 14.1087 2.41669 12.7669 2.41669 10.0833Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.0791C12.3705 17.0791 12.6709 17.3794 12.6709 17.7499V19.6809L16.0689 20.9551C16.3726 21.069 16.5513 21.3838 16.4934 21.703C16.4356 22.0221 16.1577 22.2541 15.8334 22.2541H8.16669C7.84236 22.2541 7.56448 22.0221 7.50662 21.703C7.44875 21.3838 7.62747 21.069 7.93114 20.9551L11.3292 19.6809V17.7499C11.3292 17.3794 11.6295 17.0791 12 17.0791Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.c47885abceb4c8e67e76b65b03850fb4.svg";
export { ForwardRef as ReactComponent };